module.exports = __webpack_public_path__ + "img/cnt2-m.ee14b134.jpg";